import React from 'react';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import T from 'i18n-react';
import Link from '@material-ui/core/Link';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { OPEN_EXTERNAL_BROWSER_QUERY } from '~/src/core/variables';
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from '../../routing';

type ServiceAgreementCheckboxProps = Pick<
  CheckboxProps,
  'checked' | 'onChange'
>;

const TermsOfService = () => (
  <Link
    href={`${TERMS_OF_SERVICE}?${OPEN_EXTERNAL_BROWSER_QUERY}`}
    target="_blank"
    rel="noopener"
  >
    {T.translate('termsOfService')}
  </Link>
);

const PrivacyPolicy = () => (
  <Link
    href={`${PRIVACY_POLICY}?${OPEN_EXTERNAL_BROWSER_QUERY}`}
    target="_blank"
    rel="noopener"
  >
    {T.translate('privacyPolicy')}
  </Link>
);

const ServiceAgreementCheckbox = ({
  checked,
  onChange,
}: ServiceAgreementCheckboxProps) => (
  <FormControlLabel
    control={<Checkbox checked={checked} onChange={onChange} />}
    label={T.translate('applicant.new.confirmation', {
      tos: <TermsOfService />,
      privacy: <PrivacyPolicy />,
    })}
  />
);

export default ServiceAgreementCheckbox;
